module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_04@3x-a44bd07b1b36f18bec652c4e4a6a8df4.webp";